import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '../../assets/scripts/jquery.share.min.js'

$(document).ready(function(){
  $('.article-article img').each(function(index,value){
    if($(this).width() > 200){
      $(this).addClass('block')
    }
  })

  $('.article-reply .reply-btn').on('click',function(){
    let username = $(this).closest('.title').find('.info .username').html()
    $('.reply-form .replyto').show().find('.username').html(username)
    $('#reply-message').focus()
  })
  $('#reply-message').blur(function(){
    $('.reply-form .replyto').hide()
  })

  if($('.section2 .article-article').text().indexOf('About ComNav Technology') > -1){
    $('.section2 .articl-btm').hide()
  }
})